<form action="#" id="frmRMD" name="frmRMD" novalidate role="form" class="needs-validation">

  <div class="row mb-1" *ngIf="mode === 'grid' && account">
    <label class="col-md-4 col-form-label">Account</label>
    <div class="col-md-8">
      <div class="form-control bg-light">
        <div><strong>Account #:</strong> {{ account.accountNumber }}</div>
        <div>{{ account.accountName }}</div>
      </div>
    </div>
  </div>

  <!-- IRA Ownership Status -->
  <ng-container *ngIf="mode !== 'grid'; else paramIraType">
    <!-- Dropdown for non-grid mode -->
    <div class="row mb-1">
      <label for="isIRAInherited" class="col-md-4 col-form-label">
        IRA Calculator (IRA Type)
      </label>
      <div class="col-md-4">
        <select id="isIRAInherited" name="isIRAInherited"
                class="form-select"
                [(ngModel)]="selIsIRAInherited"
                (ngModelChange)="onIsIRAInheritedChange($event)"
                tabindex="6">
          <option *ngFor="let itm of isIRAInheritedOptions" [ngValue]="itm">
            {{ itm.optionName }}
          </option>
        </select>
      </div>
    </div>
  </ng-container>
  <ng-template #paramIraType>
    <!-- In grid mode, automatically set the value and display a label -->
    <div class="row mb-1">
      <label class="col-md-4 col-form-label">
        IRA Calculator (IRA Type)
      </label>
      <div class="col-md-4">
        <label class="form-control">{{ selIsIRAInherited.optionName }}</label>
      </div>
    </div>
  </ng-template>

  <div class="row mb-1">
    <label for="selInvestor" class="col-md-4 col-form-label">Current IRA Owner</label>
    <div class="col-md-8">
      <ng-container *ngIf="mode !== 'grid'; else showInvestorLabel">
        <input type="text"
               id="selInvestor"
               name="selInvestor"
               class="form-control"
               [(ngModel)]="selInvestor"
               [ngbTypeahead]="search"
               [resultFormatter]="resultFormatter"
               [inputFormatter]="inputFormatter"
               (selectItem)="onSelectInvestor($event.item)"
               container="'body'"
               placeholder="Enter the investor name..."
               tabindex="1">
        <i *ngIf="isSearching" class="glyphicon glyphicon-refresh"></i>
      </ng-container>
      <ng-template #showInvestorLabel>
        <label class="form-control">{{ account?.investorName || 'No investor name' }}</label>
      </ng-template>
    </div>
  </div>

  <!-- IRA Owner's Date of Birth -->
  <div class="row mb-1">
    <label for="iraOwnerDOB" class="col-md-4 col-form-label">IRA Owner's Date Of Birth</label>
    <div class="col-md-4">
      <input type="date" id="iraOwnerDOB" name="iraOwnerDOB" class="form-control"
             [(ngModel)]="iraOwnerDOB"
             #iraOwnerDOBField="ngModel"
             (ngModelChange)="onIraOwnerDOBChange($event, iraOwnerDOBField)"
             [max]="maxDate"
             [disabled]="iraOwnerFieldsInitiallyReadOnly"
             tabindex="2">
    </div>
  </div>

  <!-- IRA Owner's Age -->
  <div class="row mb-1">
    <label for="iraOwnerAge" class="col-md-4 col-form-label">IRA Owner's Age (as of their birthday in {{ currentYear }})</label>
    <div class="col-md-4">
      <input type="number" id="iraOwnerAge" name="iraOwnerAge"
             class="form-control"
             [(ngModel)]="iraOwnerAge"
             [disabled]="iraOwnerFieldsInitiallyReadOnly"
             (ngModelChange)="onIraOwnerAgeChange()"
             (keydown)="onIraOwnerAgeKeydown($event)"
             tabindex="3">
    </div>
  </div>

  <!-- IRA Owner's Date of Death (For Inherited IRAs) -->
  <div class="row mb-1" *ngIf="selIsIRAInherited.id === 1">
    <label for="iraOwnerDOD" class="col-md-4 col-form-label">IRA Owner's Date of Death</label>
    <div class="col-md-4">
      <input type="date" id="iraOwnerDOD" name="iraOwnerDOD" class="form-control"
             [(ngModel)]="iraOwnerDOD"
             #iraOwnerDODField="ngModel"
             (ngModelChange)="onIraOwnerDODChange($event, iraOwnerDODField)"
             [max]="maxDate"
             [disabled]="mode === 'grid' && origIraOwnerDODProvided"
             tabindex="4">
    </div>
  </div>

  <!-- Account Balance -->
  <div class="row mb-1">
    <label for="accountBalance" class="col-md-4 col-form-label">
      Account Balance (as of 12/31 of last year)
    </label>
    <div class="col-md-4">
      <input type="number" id="accountBalance" name="accountBalance"
             class="form-control"
             [(ngModel)]="accountBalance"
             [min]="0"
             (blur)="onAccountBalanceBlur()"
             (keydown)="onAccountBalanceKeydown($event)"
             tabindex="5">
    </div>
  </div>

  <!-- Beneficiary Type (Spouse, Nonspouse, Nonperson) -->
  <div class="row mb-1" *ngIf="selIsIRAInherited.id === 0">
    <label for="beneficiaryType" class="col-md-4 col-form-label">Beneficiary Type</label>
    <div class="col-md-6">
      <select id="beneficiaryType" name="beneficiaryType"
              class="form-select"
              [(ngModel)]="beneficiaryType"
              (ngModelChange)="onBeneficiaryTypeChange($event)"
              tabindex="6">
        <option value="spouse">Spouse is The Only Primary Beneficiary</option>
        <option value="nonspouse">Nonspouse Beneficiary</option>
        <option value="nonperson">Nonperson Beneficiary</option>
      </select>
    </div>
  </div>

  <!-- Beneficiary's Date of Birth or Age (for Spouse or Nonspouse) -->
  <div *ngIf="showBeneficiaryFields()">
    <div class="row mb-1">
      <label for="beneficiaryDOB" class="col-md-4 col-form-label">Beneficiary's Date of Birth</label>
      <div class="col-md-4">
        <input type="date" id="beneficiaryDOB" name="beneficiaryDOB" class="form-control"
               [(ngModel)]="beneficiaryDOB"
               #beneficiaryDOBField="ngModel"
               (ngModelChange)="onBeneficiaryDOBChange($event, beneficiaryDOBField)"
               [max]="maxDate"
               tabindex="7">
      </div>
    </div>

    <div class="row mb-1">
      <label for="beneficiaryAge" class="col-md-4 col-form-label">Beneficiary's Age</label>
      <div class="col-md-4">
        <input type="number" id="beneficiaryAge" name="beneficiaryAge"
               class="form-control"
               [(ngModel)]="beneficiaryAge"
               (ngModelChange)="onBeneficiaryAgeChange()"
               (keydown)="onBeneficiaryAgeKeydown($event)"
               tabindex="8">
      </div>
    </div>
  </div>

  <!-- Buttons -->
  <div class="row mb-1">
    <div class="col text-center">
      <button *ngIf="mode !== 'grid'" type="button" class="btn btn-warning" [disabled]="working" (click)="reset()">
        Reset
      </button>
      <button type="button" class="btn btn-primary ms-2" [disabled]="working" (click)="calculate()">
        Calculate
      </button>
      <button *ngIf="mode === 'grid'" type="button" class="btn btn-info ms-2" [disabled]="working || calculationIsDirty || !canEdit" (click)="save()">
        Save to Account
      </button>
    </div>
  </div>

  <!-- Error Messages -->
  <div *ngIf="errorMessages && errorMessages.length > 0">
    <ul class="text-danger">
      <li *ngFor="let errorMessage of errorMessages">
        {{ errorMessage }}
      </li>
    </ul>
  </div>

  <!-- Results -->
  <div *ngIf="!calculationIsDirty">
    <div class="row mb-1 text-center" *ngIf="calculatedRMD !== undefined">
      <label class="col-12 fw-bold fs-5">The {{ currentYear }} RMD is:</label>
      <div class="col-12 fs-3 fw-bold text-primary">{{ calculatedRMD | currency }}</div>
      <div class="col-12 fs-6">Using IRS Life Expectancy Table {{ irsTableUsed }}</div>
      <div class="col-12 fs-6">ULT Factor: {{ calculationFactorUsed | number: '1.1-1' }}</div>
    </div>
  </div>

</form>
